import { IJobListen } from "./jobReducer";

export function updateJobs(jobs: IJobListen) {
    return {
        type: "PROGRESS_UPDATE_JOB",
        payload: jobs
    }
}

export function refreshJobs(jobs: IJobListen) {
    return {
        type: "PROGRESS_REFRESH_JOB",
        payload: jobs
    }
}